import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    borderTop: `2px solid ${colors.gray.l90}`,
    paddingTop: '48px',
  },
  heading: {
    marginBottom: '8px',
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '-0.25px',
  },
  headingContainer: {
    marginRight: '0px',
    marginLeft: '0px',
  },
  scrollContainer: {
    [theme.breakpoints.down(960)]: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      overflowX: 'scroll',
      '&::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar for Chrome, Safari and Opera
      '-ms-overflow-style': 'none', // Hide scrollbar for IE and Edge
      scrollbarWidth: 'none', // Hide scrollbar for Firefox
    },
  },
  cardsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(23%, auto))',
    columnGap: '24px',
    [theme.breakpoints.down(960)]: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
    },
  },
}));
